var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashtagIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#FF9900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4176 11.6986H18.05V14.6571H14.0544L13.4956 19H10.3382L10.8971 14.6571H6.78971L6.23088 19H3.10147L3.66029 14.6571H0V11.6986H4.02353L4.61029 7.30143H0.95V4.34286H4.97353L5.53235 0H8.66176L8.10294 4.34286H12.2103L12.7691 0H15.8985L15.3397 4.34286H18.9721L19 7.30143H14.9765L14.4176 11.6986ZM11.2603 11.6986L11.8471 7.30143H7.73971L7.15294 11.6986H11.2603Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagIcon);
export default __webpack_public_path__ + "static/media/HashtagIcon.6651b30f502733094715122a76892699.svg";
export { ForwardRef as ReactComponent };